import ATS from './components/ATS.vue'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        name:'ATS Page',
        component: ATS,
        path: '/'
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router